// extracted by mini-css-extract-plugin
module.exports = {"group":"az_kqb","actionCandidates":"az_lqb","carousel":"az_mqb","actionCandidatesTitle":"az_nqb","actionCandidatesContainer":"az_oqb"};